module.exports = __webpack_public_path__ + "static/media/qwant.7b2c220e.svg";